module.exports = __webpack_public_path__ + "static/11.1_ancient_greece-dd46980066408f6435a44d73dd0d237a.pdf";